module.exports = __webpack_public_path__ + "img/wengan.4f4b0691.png";